/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlockRateCommand } from '../models/BlockRateCommand';
import type { CreateExchangeRateCommand } from '../models/CreateExchangeRateCommand';
import type { CreateRecommendedRateCommand } from '../models/CreateRecommendedRateCommand';
import type { CryptoCurrencyEnum } from '../models/CryptoCurrencyEnum';
import type { ExchangeRateTypeEnum } from '../models/ExchangeRateTypeEnum';
import type { ExtendRateExpireCommand } from '../models/ExtendRateExpireCommand';
import type { GetExchangeRateRangeListQueryOrganizationFilterEnum } from '../models/GetExchangeRateRangeListQueryOrganizationFilterEnum';
import type { RemoveExchangeRateCommand } from '../models/RemoveExchangeRateCommand';
import type { ResponseData_Array_ExchangeRate2Response } from '../models/ResponseData_Array_ExchangeRate2Response';
import type { ResponseData_Array_ExchangeRateHistroryResponse } from '../models/ResponseData_Array_ExchangeRateHistroryResponse';
import type { ResponseData_ExchangeRateResponse } from '../models/ResponseData_ExchangeRateResponse';
import type { ResponseData_Guid } from '../models/ResponseData_Guid';
import type { ResponseData_PagedResponse_ExchangeRateRangeListResponse } from '../models/ResponseData_PagedResponse_ExchangeRateRangeListResponse';
import type { ResponseData_PagedResponse_RecommendedRateResponse } from '../models/ResponseData_PagedResponse_RecommendedRateResponse';
import type { UpdateExchangeRateByAOCommand } from '../models/UpdateExchangeRateByAOCommand';
import type { UpdateExchangeRateByLPCommand } from '../models/UpdateExchangeRateByLPCommand';
import type { UpdateRecommendedRateCommand } from '../models/UpdateRecommendedRateCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExchanegeRateService {
    /**
     * Получить список поставщиков
     * @returns ResponseData_Array_ExchangeRate2Response OK
     * @throws ApiError
     */
    public static getApiV1ExchanegeRateProviders({
        applicationId,
    }: {
        applicationId?: string,
    }): CancelablePromise<ResponseData_Array_ExchangeRate2Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/exchanegeRate/providers',
            query: {
                'applicationId': applicationId,
            },
        });
    }
    /**
     * Получить рекомендованные курсы
     * @returns ResponseData_PagedResponse_RecommendedRateResponse OK
     * @throws ApiError
     */
    public static getApiV1ExchanegeRateRecommended({
        cryptoCurrencies,
        currencies,
        pageNumber,
        pageSize,
    }: {
        cryptoCurrencies?: Array<CryptoCurrencyEnum>,
        currencies?: Array<number>,
        pageNumber?: number,
        pageSize?: number,
    }): CancelablePromise<ResponseData_PagedResponse_RecommendedRateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/exchanegeRate/recommended',
            query: {
                'cryptoCurrencies': cryptoCurrencies,
                'currencies': currencies,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Получить курсы
     * @returns ResponseData_PagedResponse_ExchangeRateRangeListResponse OK
     * @throws ApiError
     */
    public static getApiV1ExchanegeRateList({
        search,
        type,
        cryptoCurrencies,
        currencies,
        amountMin,
        amountMax,
        organziationFilter,
        pageNumber,
        pageSize,
    }: {
        search?: string,
        type?: ExchangeRateTypeEnum,
        cryptoCurrencies?: Array<CryptoCurrencyEnum>,
        currencies?: Array<number>,
        amountMin?: number,
        amountMax?: number,
        organziationFilter?: GetExchangeRateRangeListQueryOrganizationFilterEnum,
        pageNumber?: number,
        pageSize?: number,
    }): CancelablePromise<ResponseData_PagedResponse_ExchangeRateRangeListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/exchanegeRate/list',
            query: {
                'search': search,
                'type': type,
                'cryptoCurrencies': cryptoCurrencies,
                'currencies': currencies,
                'amountMin': amountMin,
                'amountMax': amountMax,
                'organziationFilter': organziationFilter,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Получить курс
     * @returns ResponseData_ExchangeRateResponse OK
     * @throws ApiError
     */
    public static getApiV1ExchanegeRate({
        rateId,
    }: {
        rateId?: string,
    }): CancelablePromise<ResponseData_ExchangeRateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/exchanegeRate',
            query: {
                'rateId': rateId,
            },
        });
    }
    /**
     * Получить историю курса
     * @returns ResponseData_Array_ExchangeRateHistroryResponse OK
     * @throws ApiError
     */
    public static getApiV1ExchanegeRateHistory({
        rateId,
    }: {
        rateId?: string,
    }): CancelablePromise<ResponseData_Array_ExchangeRateHistroryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/exchanegeRate/history',
            query: {
                'rateId': rateId,
            },
        });
    }
    /**
     * Создать курс
     * @returns ResponseData_Guid OK
     * @throws ApiError
     */
    public static postApiV1ExchanegeRateCreate({
        requestBody,
    }: {
        requestBody?: CreateExchangeRateCommand,
    }): CancelablePromise<ResponseData_Guid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/exchanegeRate/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Продлить курс
     * @returns ResponseData_Guid OK
     * @throws ApiError
     */
    public static putApiV1ExchanegeRateExtend({
        requestBody,
    }: {
        requestBody?: ExtendRateExpireCommand,
    }): CancelablePromise<ResponseData_Guid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/exchanegeRate/extend',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Удалить курсы
     * @returns ResponseData_Guid OK
     * @throws ApiError
     */
    public static deleteApiV1ExchanegeRateRemove({
        requestBody,
    }: {
        requestBody?: RemoveExchangeRateCommand,
    }): CancelablePromise<ResponseData_Guid> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/exchanegeRate/remove',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Изменить курс
     * @returns ResponseData_Guid OK
     * @throws ApiError
     */
    public static putApiV1ExchanegeRateUpdateProvider({
        requestBody,
    }: {
        requestBody?: UpdateExchangeRateByLPCommand,
    }): CancelablePromise<ResponseData_Guid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/exchanegeRate/update/provider',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Добавить рекомендованный курс
     * @returns ResponseData_Guid OK
     * @throws ApiError
     */
    public static postApiV1ExchanegeRateRecommendedCreate({
        requestBody,
    }: {
        requestBody?: CreateRecommendedRateCommand,
    }): CancelablePromise<ResponseData_Guid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/exchanegeRate/recommended/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Изменить рекомендованный курс
     * @returns ResponseData_Guid OK
     * @throws ApiError
     */
    public static postApiV1ExchanegeRateRecommendedUpdate({
        requestBody,
    }: {
        requestBody?: UpdateRecommendedRateCommand,
    }): CancelablePromise<ResponseData_Guid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/exchanegeRate/recommended/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Заблокировать курс
     * @returns ResponseData_Guid OK
     * @throws ApiError
     */
    public static putApiV1ExchanegeRateBlock({
        requestBody,
    }: {
        requestBody?: BlockRateCommand,
    }): CancelablePromise<ResponseData_Guid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/exchanegeRate/block',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Изменить
     * @returns ResponseData_Guid OK
     * @throws ApiError
     */
    public static putApiV1ExchanegeRateUpdateAdmin({
        requestBody,
    }: {
        requestBody?: UpdateExchangeRateByAOCommand,
    }): CancelablePromise<ResponseData_Guid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/exchanegeRate/update/admin',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
